import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { Explore } from './pages/Explore';
import { CreatorProfile } from './pages/CreatorProfile';
import { Dashboard } from './pages/Dashboard';
import { api, User } from './lib/api';

export const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const checkAuth = async () => {
    const jwt = localStorage.getItem('solemate_jwt');
    if (!jwt) {
      setLoading(false);
      return;
    }

    try {
      const res = await api.me();
      setUser(res.user);
    } catch (err) {
      console.error('Session restoration failed', err);
      api.logout();
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const handleAuthSuccess = (authenticatedUser: User) => {
    setUser(authenticatedUser);
  };

  const handleLogout = () => {
    setUser(null);
  };

  const handleUserUpdate = (updatedUser: User) => {
    setUser(updatedUser);
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg-primary)',
        color: 'white',
        fontFamily: 'var(--font-heading)'
      }}>
        <div style={{ fontSize: '4rem', animation: 'bounce 1.5s infinite' }}>🦶</div>
        <h2 style={{ marginTop: '1rem', letterSpacing: '0.05em' }}>SOLEMATE IS LOADING...</h2>
      </div>
    );
  }

  return (
    <Layout 
      user={user} 
      onAuthSuccess={handleAuthSuccess} 
      onLogout={handleLogout}
    >
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/explore" element={<Explore user={user} />} />
        <Route path="/creator/:id" element={<CreatorProfile user={user} />} />
        <Route 
          path="/dashboard" 
          element={
            <Dashboard 
              user={user} 
              onUserUpdate={handleUserUpdate} 
            />
          } 
        />
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};
export default App;
